import React, { FC } from 'react';
import { ArticleItem, type IArticleItem, type IArticle } from '../ArticleItem/ArticleItem';
import { Container } from '../Container/Container';
import styles from './Magazine.css';

export type { IArticle };

export interface IMagazine {
  main: IArticle;
  articles: IArticleItem[];
}

export const Magazine: FC<IMagazine> = ({ main: { title, imageUrl, url }, articles }) => {
  return (
    <Container dataName="Magazine">
      <a href="/magazine-zagorodnaya/" className={styles['magazine-link']}>
        Советы по покупке домов и участков
      </a>
      <div className={styles['magazine-block']}>
        <div className={styles['magazine-delimiter']} />
        <div className={styles['articles-widget']}>
          <a href={url} className={styles['articles-main']}>
            <div className={styles['articles-main-image']} style={{ backgroundImage: `url(${imageUrl})` }} />
            <div className={styles['articles-main-content']}>
              <div className={styles['articles-main-type']}>СТАТЬИ</div>
              <div className={styles['articles-main-title']}>{title}</div>
            </div>
          </a>
          <div className={styles['articles-container']}>
            {articles.map((item, i) => (
              <ArticleItem key={`article-${i}`} {...item} />
            ))}
            <a href="/magazine-zagorodnaya/" className={styles['articles-view-all']}>
              Все статьи
            </a>
          </div>
        </div>
      </div>
    </Container>
  );
};
